import React, { useCallback, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Grid
} from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
  FormWithRedirect,
  ReferenceArrayInput,
  SaveButton,
  useCreate,
  useQuery,
  Loading
} from 'react-admin';

import GridInput from '../../core/components/inputs/GridInput';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import { Typography } from '@material-ui/core';
import useNotifyServerError from '../../core/hooks/useNotifyServerError';

const styles = () => ({
  addButton: {
    border: '1px solid #E0E0E0',
    background: '#FFFFFF',
    marginLeft: '10px',
    marginTop: '10px',
    height: '30px'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  },
  title: {
    flex: 1,
    paddingTop: '20px'
  }
});

const useStyles = makeStyles({
  loading: {
    height: 'calc(100vh - 230px)'
  }
});

const CategoryTermsRelationsGridComponent = props => {
  const { existingRelations, choices, categoryTermId, ...rest } = props;
  const classes = useStyles();
  let { data, loading } = useQuery({
    type: 'getManyReference',
    resource: 'categorytermsrelations',
    payload: {
      target: 'categoryTermIds',
      id: categoryTermId,
      sort: {
        order: 'ASC'
      }
    }
  });
  if (loading) return <Loading className={classes.loading} />;
  const existingRelationsCategoryIds =
    (data && data.map(e => e.categoryId)) || [];
  const availableChoices = choices.filter(
    e => !existingRelationsCategoryIds.includes(e.id)
  );
  return (
    <GridInput
      {...rest}
      choices={availableChoices}
      optionValueLabel={'Category ID'}
      optionTextLabel={'Category Name'}
    />
  );
};

const AddCategories = props => {
  const { classes, categoryTermId, onChange, ids } = props;
  const [showDialog, setShowDialog] = useState(false);

  const [create] = useCreate('categorytermsrelations');
  const notifyServerError = useNotifyServerError();

  const handleClose = useCallback(() => {
    setShowDialog(false);
  }, [setShowDialog]);

  const handleOpen = useCallback(() => {
    setShowDialog(true);
  }, [setShowDialog]);

  const handleSubmit = async values => {
    const payload = values.categories.map(currentValue => {
      return {
        categoryTermId: categoryTermId,
        categoryId: currentValue
      };
    });
    create(
      { payload: { data: payload } },
      {
        onSuccess: () => {
          setShowDialog(false);
          onChange();
        },
        onFailure: notifyServerError
      }
    );
  };

  const validateCategories = value => {
    if (Array.isArray(value) && value.length < 1) {
      return 'At least one Category must be selected';
    }
    return undefined;
  };

  return (
    <>
      {/* Show grid label only if there are some records, otherwise Empty component will render title itself */}
      {ids && ids.length > 0 && (
        <Typography component="h5" variant="h5" classes={{ h5: classes.title }}>
          {'Related Categories'}
        </Typography>
      )}
      <Button
        color="primary"
        onClick={handleOpen}
        label="Add Categories"
        className={classes.addButton}
        disableFocusRipple
      >
        Add Categories
      </Button>
      <FormWithRedirect
        initialValues={{ categoties: [], categoryId: null }}
        toolbar={null}
        // We override the redux-form name to avoid collision with the react-admin main form
        resource="categories"
        // We override the redux-form onSubmit prop to handle the submission ourselves
        save={handleSubmit}
        className={classes.form}
        variant="standard"
        margin="normal"
        render={({ handleSubmitWithRedirect, pristine, saving }) => (
          <Dialog
            fullWidth
            open={showDialog}
            aria-label={`Add Categories`}
            maxWidth="sm"
            onClose={(event, reason) => {
              if (reason === 'backdropClick') return null;
              handleClose();
            }}
          >
            <DialogTitleWithCloseButton onClose={handleClose}>
              {'Add Category To Category Term'}
            </DialogTitleWithCloseButton>
            <DialogContent>
              <Grid container spacing={1} style={{ width: '100%' }}>
                <Grid item sm={12}>
                  <ReferenceArrayInput
                    label=""
                    optionText="Category Name"
                    optionValue="Category ID"
                    resource="categories"
                    reference="categories"
                    source="categories"
                    filter={{
                      subType: 'REPORTING'
                    }}
                    perPage={-1}
                    sort={{ field: 'name', order: 'ASC' }}
                    validate={[validateCategories]}
                  >
                    <CategoryTermsRelationsGridComponent
                      categoryTermId={categoryTermId}
                    />
                  </ReferenceArrayInput>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <SaveButton
                handleSubmitWithRedirect={handleSubmitWithRedirect}
                label={'Add'}
                icon={<></>}
              />
              <Button
                onClick={handleClose}
                variant="outlined"
                color="primary"
                //disabled={submitting}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        )}
      />
    </>
  );
};

export default withStyles(styles)(AddCategories);
